import * as actions from './actions'

const catalogCluesModule = {
    namespaced: true,
    actions,
}

export default catalogCluesModule
